import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trainerLink"]

  updateLinks() {
    const checkbox = document.getElementById("use_extension")
    const useExtension = checkbox && checkbox.checked

    this.trainerLinkTargets.forEach((link) => {
      const url = new URL(link.href)
      if (useExtension) {
        url.searchParams.set("use_extension", "1")
      } else {
        url.searchParams.delete("use_extension")
      }
      link.href = url.toString()
    })
  }
}
